import swal from 'sweetalert2';
import get from 'lodash/get';

import config from 'config';
import { CurrencyInfoModel } from './models';


export const state = {
  cartOpen: false,
  currencyInfo: new CurrencyInfoModel(),
  userLoggedIn: null,
  cartStyle: null,
  userTimeout: null,
  grecaptchaLoaded: false,
  headerCollapsed: false,
  scrollingUp: false,
  hideFixedHeader: true,
  campaignErrorInfo: null,
  isUserAdmin: false,
};

export const mutations = {
  initializeUserTimeout(state, dispatch) {
    clearTimeout(state.userTimeout);

    if (state.userLoggedIn) {
      state.userTimeout = setTimeout(() => {
        dispatch('logout');

        swal.fire({
          type: 'info',
          confirmButtonColor: config.PRIMARY_COLOR,
          title: 'You have been automatically logged out due to inactivity.',
        });
      }, 50 * 60000);
    }
  },

  clearUserTimeout(state) {
    clearTimeout(state.userTimeout);
  },

  updatePaginatableCollection(state, { collectionObject, data, properties = '_embedded.items' }) {
    collectionObject.collection = [...collectionObject.collection, ...get(data, properties)];
    collectionObject.initialized = true;
    collectionObject.total = data.total_results;

    if (get(data, properties).length === collectionObject.limit) {
      collectionObject.page++;
      collectionObject.canLoad = true;
    } else {
      collectionObject.canLoad = false;
    }
  },

  resetPaginatableCollection(state, collectionObject) {
    collectionObject.collection = [];
    collectionObject.page = 0;
    collectionObject.total = 0;
    collectionObject.canLoad = true;
    collectionObject.initialized = false;
  },
};